import React, { ReactElement } from 'react';

import './HeaderTile.scss';

interface TileProps {
    title: string;
    text?: string;
    children?: React.ReactNode;
}

const HeaderTile = (props: TileProps): ReactElement => {
    return (
        <div className='header-tile'>
            <div className='header-tile-title'>{props.title}</div>
            <div className='header-tile-text'>
                {props.text}
            </div>
        </div>
    );
};

export default HeaderTile;
